var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{style:({ width: '400px' }),attrs:{"header":_vm.titulo,"visible":_vm.showProgreso,"modal":true,"position":"center","closable":_vm.cerrar}},[_c('ProgressBar',{attrs:{"mode":"indeterminate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }